import { getSelectedTableView } from 'owa-mail-list-store';
import type { ActionSource } from 'owa-analytics-types';
import { lazyReportItems } from 'owa-mail-triage-action';
import { ReportType } from 'owa-reporting';
import getEffectiveRowKeys from 'owa-mail-reading-pane-store/lib/utils/getEffectiveRowKeys';

export default function onMarkAsPhishing(actionSource: ActionSource): void {
    const tableView = getSelectedTableView();
    const rowKeys = getEffectiveRowKeys(tableView);

    lazyReportItems.importAndExecute(ReportType.Phishing, rowKeys, tableView, actionSource);
}
